import { useNotification } from '@/shared/ui'
import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation } from '@tanstack/vue-query'
import { useRouter } from 'vue-router'
import { useAuth } from '@/entities/Auth'

const useLogout = () => {
  const { addError } = useNotification()
  const { deleteToken, deleteAuth, setCurrentPage } = useAuth()
  const router = useRouter()
  const http = useHttp()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => http.post('/auth/logout', data),
  })

  /* Отправка формы */
  const logout = async (data: any = {}) => {
    try {
      await mutation.mutateAsync(data)

      deleteToken()
      deleteAuth()
      setCurrentPage(window.location.pathname)

      await router.push('/auth/login')
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    logout,
  }
}

export { useLogout }
